import brandColors from 'styles/brandColors';

/**
 * Colors
 *
 * From: https://app.frontify.com/d/hJ06zBI7iZ1W/pulse-dashboard-style-guide
 */

export default {
  // (Note - Dylan) Added brand colors for more coverage in our theme object
  brandColors,

  // Material
  canvasColor: '#FFFFFF',
  secondaryTextColor: '#757575',
  contrastPrimary2Color: 'rgb(54, 28, 93)',
  hoverPrimary2Color: '#2e1b6c',

  // White/black
  white: '#fff',
  black: '#000',
  contentBgColor: '#f9fbfd',

  // Hover over color
  hoverGradient: '#f3f3f3',

  // 0% opacity background (used for overriding background colors)
  opacity0: 'rgba(255, 255, 255, 0)',

  gray: '#d3d3d3',
  lightestGray: '#f8fafb',
  lightGray: '#eee',
  counterLightGray: '#e8e8e8',

  grayBlue: '#F3F5F9',
  blue: '#6092df',
  darkBlue: '#4e6987',
  sidebarGray: '#18202c',

  green: '#5fc36b',
  frogGreen: '#7ed321',

  orange: '#ff930a',
  red: '#f15b5b',
  yellow: '#F9CF71',

  // opacity
  secondaryMainOpacity: 'rgba(41, 98, 255, 0.25)',

  // REDESIGN COLORS
  // Colors
  primary: '#60269E',
  lightPrimary: '#7F51B1',
  darkPrimary: '#431A6E',
  secondary: '#2962FF',
  lightSecondary: '#5381FF',
  darkSecondary: '#1C44B2',
  warning: '#F5A800',
  info: '#2962FF',
  success: '#61A60E',
  error: '#FF342C',
  divider: 'rgba(33, 33, 33, 0.08)',
  navDivider: 'rgba(255, 255, 255, 0.12)',

  // Typography
  primaryText: '#212121',
  gray1: '#666666',
  gray2: '#979797',
  navText: 'rgba(255, 255, 255, 0.7)',
};
